import React, { useEffect } from "react";
import { useTheme, useMediaQuery, Box, Tabs, Tab } from "@mui/material";
import { useLocation, useNavigate, Outlet, useParams } from "react-router-dom";

function FinancialTabs() {
	const { symbol } = useParams();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const location = useLocation();
	const navigate = useNavigate();

	// Define routes and their respective tab indices
	const tabRoutes = [
		`/stock-analyzer/${symbol}/financials/income-statement`,
		`/stock-analyzer/${symbol}/financials/balance-sheet`,
		`/stock-analyzer/${symbol}/financials/cash-flow`,
	];

	// Determine the current tab based on the URL
	const currentTab = tabRoutes.findIndex((route) =>
		location.pathname.startsWith(route)
	);
	// const currentTab = tabRoutes.indexOf(location.pathname);
	const [value, setValue] = React.useState(
		currentTab !== -1 ? currentTab : false
	);

	useEffect(() => {
		if (currentTab !== value) {
			setValue(currentTab !== -1 ? currentTab : false);
		}
	}, [location.pathname, currentTab, value]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		navigate(tabRoutes[newValue]); // Navigate programmatically
	};

	const tabSx = {
		border: "0.75px solid",
		borderRadius: 2,
		textTransform: "none",
		fontWeight: "bold",
		fontSize: isMobile ? ".8rem" : ".9rem",
		marginLeft: isMobile ? "0.2rem" : "0.5rem",
		marginRight: isMobile ? "0.2rem" : "0.5rem",
		padding: 0.75,
		minHeight: "1rem", // Reduce the minimum height
		//   lineHeight: '1rem', // Adjust line height to match font size
	};

	return (
		<>
			<Box
				sx={{
					// border: '1px dashed grey',
					maxWidth: "100%",
					bgcolor: "background.paper",
					display: "flex",
					justifyContent: "center",
					marginTop: "1.5rem",
					marginLeft: "auto",
					marginRight: "auto",
					// padding: '1rem',
					// height: '0.1rem',
				}}
			>
				<Tabs
					value={value}
					onChange={handleChange}
					variant="scrollable"
					//   scrollButtons="auto"
					scrollButtons={false}
					//   allowScrollButtonsMobile
					aria-label="financial statements tabs"
					sx={{
						"& .MuiTabs-indicator": {
							display: "none", // Hide the indicator
						},
						minHeight: "1rem", // Ensure Tabs container also has reduced height
					}}
				>
					<Tab label="Income Statement" sx={tabSx} />
					<Tab label="Balance Sheet" sx={tabSx} />
					<Tab label="Cash Flow" sx={tabSx} />
				</Tabs>
			</Box>
			{/* Render the nested route components */}
			<Outlet />
		</>
	);
}

export default function Financials() {
	return <FinancialTabs></FinancialTabs>;
}
